import React from "react";
import Header from "../common/Header";
import Footer from "../common/Footer";
import Categories from "../common/Categories";
import Headerstart from "../common/Headerstart";

const CarsPage = () => {
  return (
    <>
      <Header />
      <Headerstart link={"Cars"} />
      <Categories />
      <Footer />
    </>
  );
};

export default CarsPage;
